import { useEffect } from "react"

import { api } from "@/lib/api"
import { setChangelogNotificationAllowed } from "@/lib/widget-changelog-gate"

// Records whether this workspace may get the widget's "What's new" popup, read
// back at init on the next load since the widget boots before this query lands.
export function ChangelogNotificationGate() {
	const { data: trialInfo } = api.workspace.trialInfo.useQuery(undefined, {
		cacheTime: Infinity,
		staleTime: Infinity,
	})

	useEffect(() => {
		if (!trialInfo) return
		setChangelogNotificationAllowed(!trialInfo.isTrial)
	}, [trialInfo])

	return null
}
